import { render, staticRenderFns } from "./Contact.vue?vue&type=template&id=6e4f1703&"
import script from "./Contact.vue?vue&type=script&lang=js&"
export * from "./Contact.vue?vue&type=script&lang=js&"
import style0 from "./Contact.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e4f1703')) {
      api.createRecord('6e4f1703', component.options)
    } else {
      api.reload('6e4f1703', component.options)
    }
    module.hot.accept("./Contact.vue?vue&type=template&id=6e4f1703&", function () {
      api.rerender('6e4f1703', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/components/pages/Contact.vue"
export default component.exports